// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jrpw557G {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  padding: 2rem 1rem;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y;
}
.jrpw557G::before {
  content: '';
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: -1;
  pointer-events: none;
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .jrpw557G {
    display: block;
    -webkit-box-align: initial;
    -webkit-align-items: initial;
            align-items: initial;
    -webkit-box-pack: initial;
    -webkit-justify-content: initial;
            justify-content: initial;
    padding: 0.75rem 1rem;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-y;
  }
  .jrpw557G::after {
    content: '';
    display: block;
    height: 0.75rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .jrpw557G {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
            justify-content: center;
    padding: 0.5rem 1rem;
  }
  .jrpw557G::after {
    display: none;
  }
}
.yuTHIwBs {
  position: relative;
  width: 100%;
  max-width: 25.875rem;
  box-sizing: border-box;
  padding: 2.5875rem 2.3rem 2.3rem;
  background: #fffdf4;
  border-radius: 2.3rem;
  box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.18);
  -webkit-animation: eyur50t1 0.3s ease;
          animation: eyur50t1 0.3s ease;
  overflow: visible;
  text-align: center;
}
@media (max-width: 767px) {
  .yuTHIwBs {
    max-width: 90%;
    padding: 2.3rem 1.725rem 2.0125rem;
    border-radius: 2.0125rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .yuTHIwBs {
    width: min(25.875rem, 82vw);
    max-width: min(25.875rem, 82vw);
    margin: auto;
  }
}
@-webkit-keyframes eyur50t1 {
  from {
    opacity: 0;
    -webkit-transform: translateY(1.25rem);
            transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
@keyframes eyur50t1 {
  from {
    opacity: 0;
    -webkit-transform: translateY(1.25rem);
            transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
.lAXgXUPt {
  background: none;
  margin: 0;
  outline: none;
  font-family: inherit;
  position: absolute;
  top: -0.5rem;
  right: -1rem;
  width: 3.5rem;
  height: 3.5rem;
  padding: 0;
  border: none;
  background: transparent;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  cursor: pointer;
  z-index: 2;
  -webkit-transition: -webkit-transform 0.2s ease;
  transition: -webkit-transform 0.2s ease;
  transition: transform 0.2s ease;
  transition: transform 0.2s ease, -webkit-transform 0.2s ease;
}
.lAXgXUPt:hover {
  -webkit-transform: scale(1.05);
          transform: scale(1.05);
}
.lAXgXUPt:active {
  -webkit-transform: scale(0.95);
          transform: scale(0.95);
}
@media (max-width: 767px) {
  .lAXgXUPt {
    top: -0.625rem;
    right: -0.875rem;
    width: 3rem;
    height: 3rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .lAXgXUPt {
    top: -0.625rem;
    right: -0.875rem;
    width: 3rem;
    height: 3rem;
  }
}
.So3db6W_ {
  width: 100%;
  height: 100%;
  display: block;
  -o-object-fit: contain;
     object-fit: contain;
}
.rD7hWlHf {
  margin: 0 0 1rem;
  font-size: 1.5rem;
  font-weight: bold;
  color: #5e5447;
  line-height: 1.3;
}
@media (max-width: 767px) {
  .rD7hWlHf {
    font-size: 1.25rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .rD7hWlHf {
    margin-bottom: 1rem;
    font-size: 1.25rem;
    line-height: 1.3;
  }
}
.fviUVfxN {
  margin: 0 0 1.5rem;
  font-size: 1rem;
  font-weight: bold;
  color: #5e5447;
  line-height: 1.5;
}
@media (max-width: 767px) {
  .fviUVfxN {
    font-size: 0.875rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .fviUVfxN {
    margin-bottom: 1.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
  }
}
.Wh_cJu2W {
  margin: 0 0 2rem;
  font-size: 1.125rem;
  font-weight: bold;
  color: #5e5447;
  line-height: 1.4;
  word-break: break-all;
}
@media (max-width: 767px) {
  .Wh_cJu2W {
    font-size: 1rem;
    margin-bottom: 1.5rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .Wh_cJu2W {
    margin-bottom: 1.5rem;
    font-size: 1rem;
    line-height: 1.4;
  }
}
.aZcSH689 {
  background: none;
  padding: 0;
  outline: none;
  font-family: inherit;
  display: block;
  width: 100%;
  margin: 0;
  padding: 0.9375rem 1.5rem;
  background: #ff8100;
  border: none;
  border-radius: 999px;
  color: #ffffff;
  font-size: 1.125rem;
  font-weight: bold;
  cursor: pointer;
  -webkit-transition: background-color 0.2s ease, -webkit-transform 0.2s ease;
  transition: background-color 0.2s ease, -webkit-transform 0.2s ease;
  transition: background-color 0.2s ease, transform 0.2s ease;
  transition: background-color 0.2s ease, transform 0.2s ease, -webkit-transform 0.2s ease;
  min-height: 2.75rem;
  min-width: 2.75rem;
  box-sizing: border-box;
}
.aZcSH689:hover {
  background: #e67400;
}
.aZcSH689:active {
  -webkit-transform: scale(0.98);
          transform: scale(0.98);
}
@media (max-width: 767px) {
  .aZcSH689 {
    font-size: 1rem;
    padding: 0.875rem 1rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .aZcSH689 {
    font-size: 1rem;
    padding: 0.875rem 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SupportModal/SupportModal.module.less","webpack://./src/styles/mixins.less"],"names":[],"mappings":"AAUA;EACE,eAAA;EACA,QAAA;EACA,aAAA;ECgDA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EDhDA,kBAAA;EC0GA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,iCAAA;EACA,mBAAA;ADhHF;ACkHE;EACE,WAAA;EACA,eAAA;EACA,QAAA;EACA,+BAAA;EACA,0BAAA;EACA,kCAAA;EACA,WAAA;EACA,oBAAA;ADhHJ;ACsHE;EAAA;IACE,cAAA;IACA,0BAAA;IAAA,4BAAA;YAAA,oBAAA;IACA,yBAAA;IAAA,gCAAA;YAAA,wBAAA;IACA,qBAAA;IACA,kBAAA;IACA,gBAAA;IACA,4BAAA;IACA,iCAAA;IACA,mBAAA;EDnHF;ECqHE;IACE,WAAA;IACA,cAAA;IACA,eAAA;EDnHJ;AACF;AAtBE;EAAA;IACE,oBAAA;IAAA,qBAAA;IAAA,aAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;IACA,wBAAA;IAAA,+BAAA;YAAA,uBAAA;IACA,oBAAA;EAyBF;EAvBE;IACE,aAAA;EAyBJ;AACF;AArBA;EACE,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,sBAAA;EACA,gCAAA;EAEA,mBAAA;EACA,qBAAA;EACA,+CAAA;EACA,qCAAA;UAAA,6BAAA;EACA,iBAAA;EACA,kBAAA;AAsBF;AC9DE;EAAA;ID4CE,cAAA;IACA,kCAAA;IAEA,wBAAA;EAqBF;AACF;AAnBE;EAAA;IACE,2BAAA;IACA,+BAAA;IACA,YAAA;EAsBF;AACF;AAnBA;EACE;IACE,UAAA;IACA,sCAAA;YAAA,8BAAA;EAqBF;EAnBA;IACE,UAAA;IACA,gCAAA;YAAA,wBAAA;EAqBF;AACF;AA7BA;EACE;IACE,UAAA;IACA,sCAAA;YAAA,8BAAA;EAqBF;EAnBA;IACE,UAAA;IACA,gCAAA;YAAA,wBAAA;EAqBF;AACF;AAlBA;ECiCE,gBAAA;EAEA,SAAA;EAEA,aAAA;EACA,oBAAA;EDpCA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,+CAAA;EAAA,uCAAA;EAAA,+BAAA;EAAA,4DAAA;AAuBF;AArBE;EACE,8BAAA;UAAA,sBAAA;AAuBJ;AApBE;EACE,8BAAA;UAAA,sBAAA;AAsBJ;AChHE;EAAA;ID8FE,cAAA;IACA,gBAAA;IACA,WAAA;IACA,YAAA;EAsBF;AACF;AApBE;EAAA;IACE,cAAA;IACA,gBAAA;IACA,WAAA;IACA,YAAA;EAuBF;AACF;AApBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;KAAA,mBAAA;AAsBF;AAnBA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAqBF;AC7IE;EAAA;ID2HE,kBAAA;EAsBF;AACF;AApBE;EAAA;IACE,mBAAA;IACA,kBAAA;IACA,gBAAA;EAuBF;AACF;AApBA;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAsBF;AChKE;EAAA;ID6IE,mBAAA;EAuBF;AACF;AArBE;EAAA;IACE,qBAAA;IACA,mBAAA;IACA,gBAAA;EAwBF;AACF;AArBA;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AAuBF;ACpLE;EAAA;IDgKE,eAAA;IACA,qBAAA;EAwBF;AACF;AAtBE;EAAA;IACE,qBAAA;IACA,eAAA;IACA,gBAAA;EAyBF;AACF;AAtBA;ECtEE,gBAAA;EACA,UAAA;EAGA,aAAA;EACA,oBAAA;EDmEA,cAAA;EACA,WAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EAEA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,2EAAA;EAAA,mEAAA;EAAA,2DAAA;EAAA,wFAAA;EC1EA,mBAAA;EACA,kBAAA;ED2EA,sBAAA;AA2BF;AAzBE;EACE,mBAAA;AA2BJ;AAxBE;EACE,8BAAA;UAAA,sBAAA;AA0BJ;AC5NE;EAAA;IDsME,eAAA;IACA,sBAAA;EA0BF;AACF;AAxBE;EAAA;IACE,eAAA;IACA,sBAAA;EA2BF;AACF","sourcesContent":["@import '@/styles/variables.less';\n@import '@/styles/mixins.less';\n\n@support-modal-bg: #fffdf4;\n@support-modal-text: #5e5447;\n@support-modal-orange: #ff8100;\n@support-modal-orange-dark: #e67400;\n@support-modal-scale: 1.15;\n@support-modal-base-width: 22.5rem;\n\n.overlay {\n  position: fixed;\n  inset: 0;\n  z-index: @z-index-modal;\n  .flex-center();\n  padding: @spacing-xl @spacing-md;\n  .modalOverlayBackdrop();\n\n  .touchLandscapeModalOverlay(0.75rem, 1rem);\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: @spacing-sm @spacing-md;\n\n    &::after {\n      display: none;\n    }\n  }\n}\n\n.modal {\n  position: relative;\n  width: 100%;\n  max-width: (@support-modal-base-width * @support-modal-scale);\n  box-sizing: border-box;\n  padding: (2.25rem * @support-modal-scale) (2rem * @support-modal-scale)\n    (2rem * @support-modal-scale);\n  background: @support-modal-bg;\n  border-radius: (2rem * @support-modal-scale);\n  box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.18);\n  animation: slideUp 0.3s ease;\n  overflow: visible;\n  text-align: center;\n  \n\n  .mobile({\n    max-width: 90%;\n    padding: (2rem * @support-modal-scale) (1.5rem * @support-modal-scale)\n      (1.75rem * @support-modal-scale);\n    border-radius: (1.75rem * @support-modal-scale);\n  });\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    width: min((@support-modal-base-width * @support-modal-scale), 82vw);\n    max-width: min((@support-modal-base-width * @support-modal-scale), 82vw);\n    margin: auto;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(1.25rem);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.closeButton {\n  .button-reset();\n  position: absolute;\n  top: -0.5rem;\n  right: -1rem;\n  width: 3.5rem;\n  height: 3.5rem;\n  padding: 0;\n  border: none;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 2;\n  transition: transform 0.2s ease;\n\n  &:hover {\n    transform: scale(1.05);\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n\n  .mobile({\n    top: -0.625rem;\n    right: -0.875rem;\n    width: 3rem;\n    height: 3rem;\n  });\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    top: -0.625rem;\n    right: -0.875rem;\n    width: 3rem;\n    height: 3rem;\n  }\n}\n\n.closeButtonImg {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: contain;\n}\n\n.title {\n  margin: 0 0 @spacing-md;\n  font-size: @font-size-xxl;\n  font-weight: bold;\n  color: @support-modal-text;\n  line-height: 1.3;\n\n  .mobile({\n    font-size: @font-size-xl;\n  });\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    margin-bottom: @spacing-md;\n    font-size: @font-size-xl;\n    line-height: 1.3;\n  }\n}\n\n.description {\n  margin: 0 0 @spacing-lg;\n  font-size: @font-size-md;\n  font-weight: bold;\n  color: @support-modal-text;\n  line-height: 1.5;\n\n  .mobile({\n    font-size: @font-size-sm;\n  });\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    margin-bottom: @spacing-lg;\n    font-size: @font-size-sm;\n    line-height: 1.5;\n  }\n}\n\n.email {\n  margin: 0 0 @spacing-xl;\n  font-size: @font-size-lg;\n  font-weight: bold;\n  color: @support-modal-text;\n  line-height: 1.4;\n  word-break: break-all;\n\n  .mobile({\n    font-size: @font-size-md;\n    margin-bottom: @spacing-lg;\n  });\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    margin-bottom: @spacing-lg;\n    font-size: @font-size-md;\n    line-height: 1.4;\n  }\n}\n\n.copyButton {\n  .button-reset();\n  display: block;\n  width: 100%;\n  margin: 0;\n  padding: 0.9375rem @spacing-lg;\n  background: @support-modal-orange;\n  border: none;\n  border-radius: 999px;\n  color: @white;\n  \n  font-size: @font-size-lg;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.2s ease, transform 0.2s ease;\n  .touch-friendly();\n  box-sizing: border-box;\n\n  &:hover {\n    background: @support-modal-orange-dark;\n  }\n\n  &:active {\n    transform: scale(0.98);\n  }\n\n  .mobile({\n    font-size: @font-size-md;\n    padding: 0.875rem @spacing-md;\n  });\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    font-size: @font-size-md;\n    padding: 0.875rem @spacing-md;\n  }\n}\n","@import './variables.less';\n\n// 响应式 Mixins\n.mobile(@rules) {\n  @media (max-width: 767px) {\n    @rules();\n  }\n}\n\n.mobileNarrow(@rules) {\n  @media (max-width: 413px) {\n    @rules();\n  }\n}\n\n.tablet(@rules) {\n  @media (min-width: 768px) and (max-width: 1023px) {\n    @rules();\n  }\n}\n\n.desktop(@rules) {\n  @media (min-width: 1024px) {\n    @rules();\n  }\n}\n\n.tablet-up(@rules) {\n  @media (min-width: 768px) {\n    @rules();\n  }\n}\n\n// 紧凑 PC（1024~1728 宽）：首页 banner 缩小与垂直微调\n.homeCompactPc(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) {\n    @rules();\n  }\n}\n\n.homeCompactPcShort(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) and (max-height: 1000px) {\n    @rules();\n  }\n}\n\n// 宽屏 PC（>1728 宽）：首页 banner 放大\n.homeWidePc(@rules) {\n  @media (min-width: 1729px) {\n    @rules();\n  }\n}\n\n// 浏览器放大/缩小时：横向裁切装饰溢出，纵向允许滚动避免内容显示不全\n.zoomScrollablePage() {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n// Flexbox Mixins\n.flex-center() {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between() {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-start() {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n// 文本省略\n.text-ellipsis() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-ellipsis-multi(@lines: 2) {\n  display: -webkit-box;\n  -webkit-line-clamp: @lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// 清除浮动\n.clearfix() {\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n}\n\n// 按钮重置\n.button-reset() {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  outline: none;\n  font-family: inherit;\n}\n\n// 触摸友好\n.touch-friendly() {\n  min-height: 2.75rem; // 44px\n  min-width: 2.75rem; // 44px\n}\n\n// 可滚动弹窗蒙版：背景 fixed 铺满视口，内容区单独滚动，避免移动端滑出未覆盖区域\n.modalOverlayBackdrop(@bg: rgba(0, 0, 0, 0.55)) {\n  box-sizing: border-box;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  touch-action: pan-y;\n\n  &::before {\n    content: '';\n    position: fixed;\n    inset: 0;\n    background: @bg;\n    backdrop-filter: blur(4px);\n    -webkit-backdrop-filter: blur(4px);\n    z-index: -1;\n    pointer-events: none;\n  }\n}\n\n// 触屏设备横屏时高度很矮，弹窗蒙版必须允许自身滚动，并从顶部开始排布。\n.touchLandscapeModalOverlay(@padding-y: @spacing-sm, @padding-x: @spacing-md) {\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    display: block;\n    align-items: initial;\n    justify-content: initial;\n    padding: @padding-y @padding-x;\n    overflow-x: hidden;\n    overflow-y: auto;\n    overscroll-behavior: contain;\n    -webkit-overflow-scrolling: touch;\n    touch-action: pan-y;\n\n    &::after {\n      content: '';\n      display: block;\n      height: @padding-y;\n    }\n  }\n}\n\n.touchLandscapeModalBox(@max-height-gap: (@spacing-sm * 2)) {\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    max-height: calc(var(--app-viewport-height, 100dvh) - @max-height-gap);\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `jrpw557G`,
	"modal": `yuTHIwBs`,
	"slideUp": `eyur50t1`,
	"closeButton": `lAXgXUPt`,
	"closeButtonImg": `So3db6W_`,
	"title": `rD7hWlHf`,
	"description": `fviUVfxN`,
	"email": `Wh_cJu2W`,
	"copyButton": `aZcSH689`
};
export default ___CSS_LOADER_EXPORT___;
